import axios from 'axios';
import { ENV_CONFIG } from './environment';

// Create axios instance with base configuration
const apiClient = axios.create({
  baseURL: ENV_CONFIG.API_BASE_URL,
  timeout: ENV_CONFIG.REQUEST_TIMEOUT,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Create separate axios instance for Eira routes
const eiraApiClient = axios.create({
  baseURL: ENV_CONFIG.EIRA_API_BASE_URL,
  timeout: ENV_CONFIG.REQUEST_TIMEOUT,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
const requestInterceptor = (config: any) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  console.log('API Request:', {
    method: config.method?.toUpperCase(),
    url: config.url,
    baseURL: config.baseURL,
    data: config.data,
    headers: config.headers
  });
  return config;
};

const requestErrorInterceptor = (error: any) => {
  console.error('API Request Error:', error);
  return Promise.reject(error);
};

// Response interceptor for error handling
const responseInterceptor = (response: any) => {
  console.log('API Response:', {
    status: response.status,
    statusText: response.statusText,
    data: response.data,
    url: response.config.url
  });
  
  // Check if response data structure is unexpected
  if (response.data && typeof response.data === 'object') {
    console.log('Response data structure:', Object.keys(response.data));
  }
  
  return response;
};

const responseErrorInterceptor = (error: any) => {
  console.error('API Response Error:', {
    status: error.response?.status,
    statusText: error.response?.statusText,
    data: error.response?.data,
    url: error.config?.url,
    message: error.message
  });
  if (error.response?.status === 401) {
    // Token expired or invalid - but don't redirect if we're already on login page
    if (window.location.pathname !== '/login' && window.location.pathname !== '/') {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
  }
  return Promise.reject(error);
};

// Apply interceptors to both clients
apiClient.interceptors.request.use(requestInterceptor, requestErrorInterceptor);
apiClient.interceptors.response.use(responseInterceptor, responseErrorInterceptor);

eiraApiClient.interceptors.request.use(requestInterceptor, requestErrorInterceptor);
eiraApiClient.interceptors.response.use(responseInterceptor, responseErrorInterceptor);

export default apiClient;
export { eiraApiClient };
